import { Component, Inject, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-questionInf-multiple-choice',
  templateUrl: './question-inf-multiple-choice.component.html',
  styleUrls: ['./question-inf-multiple-choice.component.scss']
})
export class QuestionInfMultipleChoiceComponent implements OnInit {
  @Input() informantForm: FormGroup;
  @Input() isEditValue: boolean;
  @Input() questionIndex: number;

  @Output() media = new EventEmitter();
  @Output() qMedia = new EventEmitter();
  @Output() qMediaType = new EventEmitter();

  @Output() sendArr = new EventEmitter();
  informantArray: any[] = []

  questionMediaType: string;
  questionMedia;
  choicesMedia = [];
  modalData;
  vdoDuration;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    console.log(this.modalData);
    if (!this.isEditValue) {
      this.modalData.informant_tag.forEach(e => {
        this.informantArray.push({
          tag: e,
          type: 'multi_choice',
          question: '',
          media: {
            media_type: '',
            file_name: '',
            time_again: '',
            unlimit: '',
            duration: '',
            vdo_id: '',
            file_url: ''
          },
          choices: [],
        })
      });
    } else {
      let val_informant = JSON.parse(this.modalData.value.VALUE_INFORMANT);
      val_informant.splice(0, 1);
      this.informantArray = val_informant;

      this.questionMediaType = this.modalData.value.VALUE[0].media.media_type;

      for (let i = 0; i < this.modalData.value.VALUE[0].choices.length; i++) {
        this.informantFormArray.push(
          this.fb.group({
            choice_id: [this.modalData.value.VALUE[0].choices[i].choice_id, Validators.required],
            choice_detail: [this.modalData.value.VALUE[0].choices[i].choice_detail, Validators.required],
            media: {
              media_type: this.modalData.value.VALUE[0].choices[i].media.media_type,
              file_name: this.modalData.value.VALUE[0].choices[i].media.file_name,
              file_url: this.modalData.value.VALUE[0].choices[i].media.file_url
            },
          })
        )
      }

      this.informantForm.controls['media'].setValue(this.modalData.value.VALUE[0].media);
    }

    console.log(this.informantArray);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes.questionIndex) {
      // ดำเนินการอัปเดตตามต้องการที่นี่
      this.questionIndex = parseInt(changes.questionIndex.currentValue);
    }
  }

  get informantFormArray(): FormArray {
    return this.informantForm.get('choices') as FormArray;
  }

  setQuestionInformant(question) {
    this.informantArray.forEach((el, i) => {
      if (el.question === '') {
        el.question = question;
      }
    });
  }

  setChoiceInformant(choice, index) {
    this.informantArray.forEach((el, i) => {
      if (el.choices[index].choice_detail === '') {
        el.choices[index].choice_detail = choice;
      }
    });
  }

  addChoiceAndImg(form) {
    form.push(
      this.fb.group({
        media: {
          media_type: '',
          file_name: ''
        },
        choice_detail: ['', Validators.required],
        choice_id: form.value.length + 1
      })
    );

    console.log(this.informantArray.length);
    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      console.log(i);
      this.copyAddChoiceAndImg(inf, form.value.length, i);
    }

    console.log(this.informantArray);
    console.log(this.informantForm.value);
  }

  copyAddChoiceAndImg(inf, choice_id, index) {
    console.log(index, inf);
    let obj = {
      media: {
        media_type: '',
        file_name: ''
      },
      choice_detail: '',
      choice_id: choice_id
    }

    inf.choices.push(obj);
    console.log(index, inf.choices.length)
  }

  deleteChoice(form, index) {
    form.removeAt(index);

    form.value.map((f, index) => {
      f.choice_id = index + 1;
    })

    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      this.deleteInformantChoice(inf, index);
    }

    console.log(this.informantArray);
  }

  deleteInformantChoice(inf, index) {
    inf.choices.splice(index, 1);
    inf.choices.map((el, index) => el.choice_id = index + 1)
  }

  copyArr() {
    console.log(this.informantArray);
    this.sendArr.emit(this.informantArray);
  }

  getDuration(e) {
    var video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      this.vdoDuration = video.duration;
    }
    video.src = URL.createObjectURL(e.target.files[0]);
  }

  addQuestionMedia(e, form) {
    // console.log(e);

    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);
    this.questionMediaType = fileType;
    // // console.log(fileType);
    // console.log(form);
    // console.log(e.target.files[0]);

    if (fileType === 'mp4') {
      this.getDuration(e);
    }

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg' || fileType === 'mp3' || fileType === 'mp4' || fileType === 'wav') {
      setTimeout(() => {
        if (e.target.files && e.target.files[0]) {
          const file = (e.target as HTMLInputElement).files[0];
          const type = (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') ? 'image' : (fileType === 'mp3' || fileType === 'wav') ? 'sound' : 'vdo'

          // console.log(fileType);

          form.controls['media'].patchValue({
            media_type: type,
            file_name: file.name,
            unlimit: '',
            time_again: '',
            duration: this.vdoDuration,
            vdo_id: '',
            file_url: ''
          });

          // console.log(form);
          for (let i = 0; i < this.informantArray.length; i++) {
            const inf = this.informantArray[i];
            inf.media.media_type = type;
            inf.media.file_name = file.name;
            inf.media.unlimit = '';
            inf.media.time_again = '';
            inf.media.duration = this.vdoDuration;
            inf.media.vdo_id = '';
            inf.media.file_url = '';
          }

          form.controls['media'].updateValueAndValidity();
          this.questionMedia = file;
          this.qMedia.emit(this.questionMedia);
          this.qMediaType.emit(this.questionMediaType);
          this.copyArr();
        }
      }, 300);
    } else {
      alert('การอัปโหลดรองรับไฟล์ JPG, JPEG, PNG, MP3, MP4, WAV เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  addChoiceMedia(e, form, choiceIndex) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);
    console.log(choiceIndex);
    // // console.log(e.target.value.replace(/^.*\\/, ""));

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {

      if (e.target.files && e.target.files[0]) {
        const file = (e.target as HTMLInputElement).files[0];
        const type = (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') ? 'image' : (fileType === 'mp3' || fileType === 'wav') ? 'sound' : 'vdo'

        form.controls['media'].patchValue({
          media_type: type,
          file_name: file.name,
        });
        form.controls['media'].updateValueAndValidity();
        this.choicesMedia.push(file);

        for (let i = 0; i < this.informantArray.length; i++) {
          const inf = this.informantArray[i];
          inf.choices[choiceIndex].media.file_name = file.name;
          inf.choices[choiceIndex].media.media_type = type;
        }
        // console.log(this.choicesMedia);

        console.log(this.informantArray);
        this.media.emit(this.choicesMedia);
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
    this.copyArr();

  }

  deleteImgChoice(form, index) {
    this.choicesMedia = this.choicesMedia.filter(m => form.at(index).get('media').value.file_name !== m.name);

    form.at(index).get('media').reset({
      media_type: '',
      file_name: '',
      file_url: ''
    });

    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      inf.choices[index].media.file_name = '';
      inf.choices[index].media.file_url = '';
      inf.choices[index].media.media_type = '';
    }
    this.media.emit(this.choicesMedia);
    console.log(this.informantArray);
    this.copyArr();
  }

  deleteImgQuestion(form) {
    this.questionMedia = '';
    this.questionMediaType = '';

    form.get('media').reset({
      media_type: '',
      file_name: '',
      time_again: '',
      unlimit: '',
      file_url: ''
    });

    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      inf.media.media_type = '';
      inf.media.file_name = '';
      inf.media.time_again = '';
      inf.media.unlimit = '';
      inf.media.file_url = '';
    }
    this.qMedia.emit(this.questionMedia);
    this.qMediaType.emit(this.questionMediaType);
    this.copyArr();
    
  }

  clearValueDate(form, unlimit) {
    console.log(form, unlimit);
    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      inf.media.unlimit = unlimit;
    }

    if (!form.value.media.unlimit) {
      form.get('media').patchValue({ time_again: '' });

      for (let i = 0; i < this.informantArray.length; i++) {
        const inf = this.informantArray[i];
        inf.media.time_again = '';
      }
    }

    console.log(form);
    console.log(this.informantArray);
  }

  setTimeAgain(form, e) {
    console.log(form);
    if (e.target.value > 0) {
      form.get('media').patchValue({ time_again: e.target.value });

      for (let i = 0; i < this.informantArray.length; i++) {
        const inf = this.informantArray[i];
        inf.media.time_again = e.target.value;
      }
    } else {
      form.get('media').patchValue({ time_again: 0 });
      for (let i = 0; i < this.informantArray.length; i++) {
        const inf = this.informantArray[i];
        inf.media.time_again = 0;
      }
    }
  }

}
